import React from 'react';
import './MoreInfo.css';

const MoreInfo = ({ translations }) => {
  return (
    <div className='more-info-container'>
      <div>
        <h2>Wie schnell kann ich meine Belohnung erhalten?</h2>
      </div>
      <div>
        Sie können in der Regel alle erforderlichen gesponserten Angebote innerhalb von 5-7 Tagen 
        abschließen (einige können bis zu 60 Tage dauern). Sobald Sie die erforderliche Anzahl von 
        Angeboten abgeschlossen haben, müssen Sie den Anspruchsprozess für Anreize durchlaufen, der 
        eine ID-Verifizierung erfordert. Es dauert in der Regel 5-7 Tage, bis unser Kundenservice-Team 
        Ihren Anreiz überprüft und zugestellt hat.
      </div>
    </div>
  );
};

export default MoreInfo;
